angular.
module("dx.webapp.exam").
component("dxExternalToolSettings", {
	bindings: {
		exam: "=",
		externalTools: "<",
	},
	templateUrl: "tmpl/external-tool/external-tool-settings-component/external-tool-settings-component.html",
	controller: "DxExternalToolSettingsController",
	controllerAs: "vm",
});
